import checkIsBorderlessField from 'utils/checkIsBorderlessField';
import { getFieldAreaBySeason } from 'utils/getGeometryBySeason';

const getFieldAreaInfo = (field, isNeedComa, season) => {
  if (field && checkIsBorderlessField(field, season)) return '';
  const area =
    season != null ? getFieldAreaBySeason(field, season) : field?.area;
  return `${isNeedComa ? ', ' : ''}${parseFloat(area).toFixed(2)} га`;
};

export default getFieldAreaInfo;
